import React, { useEffect, useState } from "react";
import useAuth from '../hooks/useAuth.js';
import { io } from "socket.io-client";
import axiosInstance from '../utilities/axiosInstance';
import { DOMAIN } from "../Constant.js";

const statusColors = {
    queue: "text-yellow-500",
    "processing": "text-blue-500",
    completed: "text-green-600",
    Error: "text-red-600",
};

function Request() {

    const { auth } = useAuth();
    const [progress, setProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [filteredJobs, setFilteredJobs] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    const getJobs = async () => {
        try {
            setIsLoading(true);
            const res = await axiosInstance.get("/task/progress");
            console.log("jobs", res);
            let jobs = res.data.data;
            setJobs(jobs);
            setFilteredJobs(jobs);
            setTotalPages(Math.ceil(jobs.length / pageSize));
            setCurrentPage(1);

        } catch (error) {
            console.error("Failed to fetch jobs:", error);
        } finally {
            setIsLoading(false);
        }
    }
    const updateJobs = (progressData) => {
        console.log("progressData",progressData)
        try {
            setFilteredJobs((prevJobs) =>
                prevJobs.map((job) =>
                    job.job_id == progressData.jobId
                        ? { ...job, progress: progressData.progress, status: progressData.progress == 100 ? 'completed' : progressData.progress == 0 ? 'queue' : 'processing' }
                        : job
                )
            );
        } catch (error) {
            console.log("error", error);
        }
    };

    useEffect(() => {
        getJobs();
        const socket = io(DOMAIN, {
            transports: ["websocket"],  // force only websocket
            reconnection: true,
            reconnectionAttempts: 10,
            reconnectionDelay: 1000
        });

        socket.on("connect", () => {
            console.log("✅ Connected to server:", socket.id);
            const savedJobId = localStorage.getItem("jobId");
            if (savedJobId) {
                socket.emit("joinJob", savedJobId);
            }
        });

        socket.on("progress", (data) => {
            console.log("Received progress:", data);
            setProgress(data);
            updateJobs(data);
        });

        socket.on("connect_error", (err) => {
            console.error("Connection error:", err);
        });

        socket.on("disconnect", (reason) => {
            console.log("disconnected:", reason);
        });

        // cleanup on unmount / reload
        return () => {
            socket.disconnect();
        };
    }, []);

    useEffect(() => {
        let start = (currentPage - 1) * pageSize;
        let end = start + pageSize;
        let records = filteredJobs?.slice(start, end);
        setRecordsPerPage(records);
    }, [currentPage, filteredJobs, pageSize]);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    }

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    }

    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    }

    const getVisiblePages = (total, current) => {
        if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
        const pages = [];
        if (current <= 3) {
            pages.push(1, 2, 3, '...', total);
        } else if (current >= total - 2) {
            pages.push(1, '...', total - 2, total - 1, total);
        } else {
            pages.push(1, '...', current, '...', total);
        }
        return pages;
    };

    function formatDate(dateString) {
        const date = new Date(dateString); // e.g. "2025-09-25T09:32:36.000Z"

        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const month = months[date.getMonth()];
        const day = date.getDate();

        // Add ordinal suffix
        const getDaySuffix = (d) => {
            if (d > 3 && d < 21) return "th";
            switch (d % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };

        const suffix = getDaySuffix(day);

        const year = date.getFullYear().toString().slice(-2); // "25"
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${month} ${day}${suffix} ${year}, ${hours}:${minutes}`;
    }


    return (
        <div className="px-6 ">
            <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 border-b border-gray-d-200 dark:text-white dark:border-white mb-[25px]">Welcome {(auth.profile_name !== 'null') ? auth.profile_name : auth.profile_username} - Request Page</h2>
            <div className="space-y-3 bg-gray-50 rounded-lg p-6 overflow-y-scroll max-h-[65vh]">
                {recordsPerPage && recordsPerPage.length > 0 ? (recordsPerPage.map((record) => (
                    <div
                        key={record.id}
                        className="bg-white shadow rounded-lg p-4 border border-gray-200 flex justify-between items-start bg-gray-50 hover:shadow-lg"
                    >
                        <div>
                            <div className="flex">
                                <h2 className="font-medium text-gray-800">{record.job_title}</h2>
                                <a href="#" className="text-sm ml-5 text-blue-600 hover:underline">
                                    #{record.id}
                                </a>
                            </div>
                            <div className="flex">
                                <p className="mt-2 text-xs text-gray-500">
                                    Started on {formatDate(record.started_at)}
                                </p>
                                <p className="ml-5 mt-2 text-xs text-gray-500">
                                    {record.finished_at && `Finished on ${formatDate(record.finished_at)}`}
                                </p>
                            </div>
                        </div>

                        {/* Right side: Status + Progress */}
                        <div className="w-[40%]">
                            <div className="w-[75%]">
                                {record.status !== "failed" &&
                                    <span
                                        className={`text-sm font-medium block mb-1 ${statusColors[record.status]}`}
                                    >
                                        {record.status}
                                    </span>
                                }
                                {record.error_message && (
                                    <p className="mt-1 text-sm text-red-600 h-14 overflow-hidden">{record.error_message}</p>
                                )}

                                {(record.status === "processing" ||
                                    record.status === "queue" ||
                                    record.status === "completed") && (
                                        <div className="flex items-center">
                                            <div className="w-full bg-gray-200 h-2 rounded">
                                                <div
                                                    className={`h-2 rounded ${record.status === "completed"
                                                        ? "bg-green-500"
                                                        : record.status === "processing"
                                                            ? "bg-blue-500"
                                                            : "bg-red-500"
                                                        }`}
                                                    style={{ width: `${record.progress}%` }}
                                                />
                                            </div>

                                            <div className="ml-5">{record.progress}%</div>
                                        </div>)}
                            </div>
                        </div>
                    </div>
                ))) : (
                    !isLoading && <div className="col-span-4 text-center text-gray-600 dark:text-gray-400">
                        No jobs found.
                    </div>
                )}
            </div>

            {/* Pagination */}
            {filteredJobs?.length > 0 &&
                <div className="flex justify-center mt-6">
                    <div className="paginationContainer flex items-center space-x-2 dark:text-white">
                        <button
                            type="button"
                            disabled={currentPage === 1}
                            onClick={handlePrevPage}
                            className={`w-10 h-10 rounded-full border border-gray-300 text-lg flex items-center justify-center ${currentPage === 1 ? 'cursor-not-allowed text-gray-400' : 'hover:bg-gray-100 dark:text-gray-main'}`}
                        >
                            {'<'}
                        </button>
                        <div className="flex space-x-2">
                            {getVisiblePages(totalPages, currentPage).map((page, index) => (
                                <button
                                    key={index}
                                    onClick={() => typeof page === 'number' && handlePageClick(page)}
                                    className={`w-10 h-10 rounded-full border border-gray-300 text-lg flex items-center justify-center ${currentPage === page
                                        ? 'bg-gray-300 font-semibold dark:text-gray-main'
                                        : 'hover:bg-gray-100 dark:text-gray-main'
                                        } ${typeof page !== 'number' ? 'cursor-default text-gray-400' : ''}`}
                                    disabled={typeof page !== 'number'}
                                >
                                    {page}
                                </button>
                            ))}
                        </div>
                        <button
                            type="button"
                            disabled={currentPage === totalPages}
                            onClick={handleNextPage}
                            className={`w-10 h-10 rounded-full border border-gray-300 text-lg flex items-center justify-center ${currentPage === totalPages ? 'cursor-not-allowed text-gray-400' : 'hover:bg-gray-100 dark:text-gray-main'}`}
                        >
                            {'>'}
                        </button>
                    </div>
                </div>
            }
        </div>
    );
}


export default Request;